module.exports = __webpack_public_path__ + "media/images/icons/search-f2d70afd1ebdca42594e417afc60aeef.png";